//
//
//
//
//
//
//

import {EventBus} from './../../../events';

export default {
    name: "game-vote-heading",
    props: ['user', 'votes', 'team'],
    data() {
        return {
            headType: 'home',
            remainingVotes: 3,
            totalVotes: 0,
        }
    },
    mounted() {
        this.headType = this.type;
        this.totalVotes = this.votes;
        this.remainingVotes = this.user;

        EventBus.$on('vote-player', (data) => {
            if( this.team === data.team ) {
                if( data.type === 'increment' ) {
                    this.totalVotes++;
                    this.remainingVotes--;
                } else {
                    this.totalVotes--;
                    this.remainingVotes++;
                }
            }
        })
    }
}
